import Yup from '_zari/validation/_yup'

export default Yup.object().shape({
  tipoReporte: Yup.string().required()
})
